module.exports = __webpack_public_path__ + "static/media/disinfection.81daf018.jpg";